<script>
    import { onMount } from 'svelte';
    import PackageOverview from './PackageOverview.svelte';
    import SoftwareInventoryOverview from './SoftwareInventoryOverview.svelte';
    import { ButtonGroup, Button } from 'sveltestrap';
    import { currentPage } from '../store.js';
    
    let packageOverview = 'packageOverview';
    let softwareInventory = 'softwareInventory';
    let selectedPage = packageOverview;

    onMount(async () => {      
        currentPage.set('home');
    });
</script>

<div class="d-flex">  
    <h4 class="font-weight-bold text-primary pt-2">Home</h4>
</div>
<div>
    <ButtonGroup class="ml-auto">
        <Button id="package-overview-button" color="primary" active={selectedPage == packageOverview ? true:false} class="btnGrp" on:click={() => selectedPage = packageOverview}>Manage Software</Button>
        <Button id="software-inventory-button" color="primary" active={selectedPage == softwareInventory ? true:false} class="btnGrp" on:click={() => selectedPage = softwareInventory} >Software Inventory</Button>
    </ButtonGroup>
    
    {#if selectedPage == packageOverview }
        <PackageOverview/>
    {:else}
        <SoftwareInventoryOverview/>
    {/if}
</div>

<style>
</style>